import type { Appointment } from "./types";

export function appointmentDisplayStatus(appointment: Pick<Appointment, "status" | "workOrderStatus">) {
  return appointment.workOrderStatus === "completed" || appointment.workOrderStatus === "closed"
    ? "completed"
    : appointment.status;
}
